import { Box } from '@mantine/core';

import { Text } from '~/domains/common/components/Text/Text';
import { Title } from '~/domains/common/components/Title/Title';
import { PrimaryButton } from '~/domains/common/components/Button/Button';

import { ErrorNote } from '../../components/ErrorNote';

export function FieldQueryError({
  error,
  fieldKey,
  onRetry,
}: {
  error: unknown;
  fieldKey: string;
  onRetry?: () => void;
}) {
  return (
    <div>
      <Title variant="web-subhead-medium">Error loading field</Title>
      <Text>
        There was an error loading this field. Try changing previous values or reload the page.
      </Text>
      {onRetry && (
        <Box mt="xs">
          <PrimaryButton onClick={onRetry}>Retry</PrimaryButton>
        </Box>
      )}
      <ErrorNote error={error} itemKey={fieldKey} />
    </div>
  );
}
